import parseJSON from './parse-json'

const getFingerprintsFromMenuProbingJob = job =>
  parseJSON(job.menuProbingResponse.data).fingerprints?.[0] || {}

export default getFingerprintsFromMenuProbingJob
